<template>
  <div class="custom-icon" @click="handeleEventClick()">
    <span class="material-icons"><slot /></span>
  </div>
</template>
<script lang="ts">
import { Options } from "vue-class-component";
import BaseElement from "../BaseElement.vue";

@Options({
  emits: ["click"]
})
export default class IziIcon extends BaseElement {
  public handeleEventClick() {
    this.$emit("click");
  }
}
</script>

<style lang="scss">
.custom-icon {
  width: 30px;
  height: 30px;
  text-align: center;
  padding-top: 2px;
  border-radius: 50%;
  cursor: pointer;
  color: $primary-icon;
}
.custom-icon:hover {
  background-color: #ececec;
}
</style>
